import { useSettings } from "../../context/settings";

export function useCurrency() {
  const { settings } = useSettings();

  return settings?.sales?.base_currency || '';
}

/**
 * Amounts are always shown with two decimals and thousand separators,
 * the currency code itself is appended by the caller.
 */
export function formatMoney(value) {
  return parseFloat(value ?? 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export default useCurrency;
